import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DEFAULT } from '@/constants';
import { gettext } from '@/utils/langsBook';
import clss from 'classnames';
var Logo = function(props) {
    var ref = props || {}, _textClass = ref.textClass, textClass = _textClass === void 0 ? '' : _textClass, _imgClass = ref.imgClass, imgClass = _imgClass === void 0 ? '' : _imgClass;
    return(/*#__PURE__*/ _jsxs("div", {
        className: "flex items-center cursor-pointer",
        children: [
            /*#__PURE__*/ _jsx("img", {
                className: imgClass,
                width: "48",
                height: "48",
                src: "/img/logo.png",
                alt: DEFAULT.NET.toString()
            }),
            /*#__PURE__*/ _jsx("span", {
                className: clss('ml-[14px] text-[24px] font-inter-semibold', textClass),
                children: gettext(DEFAULT.NET)
            })
        ]
    }));
};
export default Logo;
